import { CwtCrudContract, CwtModel } from "@cawita/core-front/api";
import { BillingTemplate } from "./billing.model";

@CwtModel({ name: 'invoice-template' })
@CwtCrudContract({ path: '/company/:companyId/invoice-template' })
export class InvoiceTemplate extends BillingTemplate { }